import { Validator } from '.';

export class ValidationResult
{
    public valid: boolean;
    public validators: Validator[];

    public constructor(valid: boolean, validators: Validator[])
    {
        this.valid = valid;
        this.validators = validators;
    }
}
